module.exports = __webpack_public_path__ + "img/CTA.1b537009.jpg";